import withConfigTransport from '../../../../services/config-transport/withConfigTransport'
import _VaRatingItem from './VaRatingItem.vue'

export const VaRatingItem = withConfigTransport(_VaRatingItem)
